/* ============================================
   MY COOKEES — THEME.JS
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- SCROLL REVEAL ---- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          revealObserver.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    revealEls.forEach(function (el) { revealObserver.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('visible'); });
  }

  /* ---- STAGGER PRODUCT CARDS ---- */
  var productCards = document.querySelectorAll('.product-card');
  productCards.forEach(function (card, i) {
    card.style.opacity = '0';
    card.style.transform = 'translateY(20px)';
    card.style.transition = 'all 0.6s cubic-bezier(0.16,1,0.3,1) ' + (i * 0.08) + 's';
  });
  if ('IntersectionObserver' in window) {
    var gridObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.querySelectorAll('.product-card').forEach(function (c) {
            c.style.opacity = '1';
            c.style.transform = 'translateY(0)';
          });
          gridObserver.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('.products-grid').forEach(function (g) {
      gridObserver.observe(g);
    });
  }

  /* ---- CART DRAWER ---- */
  var cartToggle = document.getElementById('cartToggle');
  var cartDrawer = document.getElementById('cartDrawer');
  var cartOverlay = document.getElementById('cartOverlay');
  var cartClose = document.getElementById('cartClose');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* ---- CART DRAWER QTY BUTTONS ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty-btn[data-key]');
    if (!btn) return;
    var key = btn.dataset.key;
    var action = btn.dataset.action;
    var qtyEl = btn.parentElement.querySelector('span');
    var current = parseInt(qtyEl ? qtyEl.textContent : 1);
    var newQty = action === 'increase' ? current + 1 : Math.max(0, current - 1);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      updateCartCount(cart.item_count);
      refreshCartDrawer(cart);
    });
  });

  /* ---- AI COUNTDOWN ---- */
  var countdownEl = document.getElementById('countdown-days');
  if (countdownEl) {
    var now = new Date();
    var endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);
    var daysLeft = Math.ceil((endOfMonth - now) / (1000 * 60 * 60 * 24));
    countdownEl.textContent = daysLeft;
  }

  /* ---- SUBSCRIPTION PLAN SELECTOR ---- */
  window.selectPlan = function (el) {
    document.querySelectorAll('.plan-card').forEach(function (c) { c.classList.remove('active'); });
    el.classList.add('active');
  };

});

/* ---- ADD TO CART (global, used by product cards and product page) ---- */
function addToCart(variantId, productName, btnEl) {
  if (btnEl) {
    btnEl.textContent = '...';
    btnEl.disabled = true;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function (r) { return r.json(); })
  .then(function (item) {
    showNotification((item.product_title || productName) + ' added!');
    updateCartCount();
    if (btnEl) {
      btnEl.textContent = '✓';
      setTimeout(function () {
        btnEl.textContent = '+ Add';
        btnEl.disabled = false;
      }, 1800);
    }
    return fetch('/cart.js');
  })
  .then(function (r) { return r.json(); })
  .then(function (cart) {
    updateCartCount(cart.item_count);
    refreshCartDrawer(cart);
  })
  .catch(function (err) {
    console.error('Cart error:', err);
    if (btnEl) { btnEl.textContent = '+ Add'; btnEl.disabled = false; }
  });
}

/* ---- SHOW NOTIFICATION TOAST ---- */
function showNotification(msg) {
  var notify = document.getElementById('cartNotify');
  var msgEl = document.getElementById('cartMsg');
  if (!notify) return;
  if (msgEl) msgEl.textContent = msg;
  notify.classList.add('show');
  clearTimeout(notify._timeout);
  notify._timeout = setTimeout(function () { notify.classList.remove('show'); }, 2800);
}

/* ---- UPDATE CART COUNT BADGE ---- */
function updateCartCount(count) {
  if (count !== undefined) {
    var badges = document.querySelectorAll('.cart-count');
    badges.forEach(function (b) { b.textContent = count; });
    return;
  }
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var badges = document.querySelectorAll('.cart-count');
      badges.forEach(function (b) { b.textContent = cart.item_count; });
    });
}

/* ---- REFRESH CART DRAWER HTML ---- */
function refreshCartDrawer(cart) {
  var itemsEl = document.getElementById('cartItems');
  var subtotalEl = document.getElementById('cartSubtotal');
  var countEl = document.getElementById('cartCount');

  if (countEl) countEl.textContent = cart.item_count;
  if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

  if (!itemsEl) return;

  if (cart.item_count === 0) {
    itemsEl.innerHTML = '<div class="cart-empty"><span style="font-size:3rem">🍪</span><p>Your cart is empty.<br>Time to add some cookies!</p><a href="/collections/all" class="btn-primary" style="margin-top:1rem">Shop Cookies</a></div>';
    return;
  }

  var html = '';
  cart.items.forEach(function (item) {
    var imgHtml = item.image
      ? '<img src="' + item.image + '" alt="' + escHtml(item.title) + '" style="width:100%;height:100%;object-fit:cover;">'
      : '<span style="font-size:2rem">🍪</span>';

    html += '<div class="cart-item" data-key="' + item.key + '">' +
      '<div class="cart-item-img">' + imgHtml + '</div>' +
      '<div class="cart-item-info">' +
        '<div class="cart-item-name">' + escHtml(item.product_title) + '</div>' +
        (item.variant_title !== 'Default Title' ? '<div class="cart-item-variant">' + escHtml(item.variant_title) + '</div>' : '') +
        '<div class="cart-item-price">' + formatMoney(item.final_price) + '</div>' +
      '</div>' +
      '<div class="cart-item-qty">' +
        '<button class="qty-btn" data-action="decrease" data-key="' + item.key + '">−</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button class="qty-btn" data-action="increase" data-key="' + item.key + '">+</button>' +
      '</div>' +
    '</div>';
  });

  itemsEl.innerHTML = html;
}

/* ---- HELPERS ---- */
function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}
function escHtml(str) {
  return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}
